/*
 * Copyright (c) Logan Group Services - Gaston Longhitano <gaston.longhitano@logangroupservices.com>
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {atom} from 'recoil';
import {INTRO_SCREEN} from './state';

export const currentGameIDState = atom({
  key: 'currentGameID',
  default: window.config?.gameID || 0
});

export const currentUserIDState = atom({
  key: 'currentUserID',
  default: 'admin'
});

export const currentSceneIDState = atom({
  key: 'currentSceneID',
  default: null
});

export const previousSceneIDState = atom({
  key: 'previousSceneID',
  default: null
});

export const currentScreenState = atom({
  key: 'currentScreenIDState',
  default: INTRO_SCREEN
});

export const sceneHistoryQueueState = atom({
  key: 'sceneHistoryQueueState',
  default: []
});

export const currentFragmentIDState = atom({
  key: 'currentFragmentID',
  default: 0
});

export const currentFragmentsInfoState = atom({
  key: 'currentFragmentsInfoState',
  default: []
});

export const currentVideoResolutionState = atom({
  key: 'currentVideoResolutionState',
  default: '480p'
});

export const currentFullscreenModeState = atom({
  key: 'currentFullscreenModeState',
  default: false
});

export const isPlayerReadyState = atom({
  key: 'isPlayerReadyState',
  default: false
});

export const displayControlsState = atom({
   key: 'displayControlsState',
   default: true
});

export const displayNavigationState = atom({
  key: 'displayNavigationState',
  default: true
});

export const displayFragmentsState = atom({
  key: 'displayFragmentsState',
  default: true
});

export const displayActionsState = atom({
  key: 'displayActionsState',
  default: true
});

export const playingState = atom({
  key: 'playingState',
  default: false
});

export const playtimeState = atom({
  key: 'playtimeState',
  default: 0
});

export const muteState = atom({
  key: 'muteState',
  default: false
});

export const currentPlayingTimeState = atom({
  key: 'currentPlayingTimeState',
  default: '00:00'
});

export const durationState = atom({
  key: 'durationState',
  default: '00:00'
});

export const viewMoreHighlightState = atom({
  key: 'viewMoreHighlightState',
  default: false
});

export const isAutoPlayingState = atom({
  key: 'isAutoPlayingState',
  default: true
});

export const isBufferingState = atom({
  key: 'isBufferingState',
  default: true
});
